import { useMutation, useQuery, useQueryClient } from 'react-query';
import { toastError, toastSuccess } from 'partial/components/react-geek-toast';
import { getQR, mfaSetup } from './actions';

export const useQR = () => {
  const { data, isLoading } = useQuery({
    queryKey: ['get-mfa-qr'],
    queryFn: getQR,
    retry: false,
  });
  const svgString = data?.data;
  const qrUrl = svgString
    ? `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgString)}`
    : null;
  return [isLoading, qrUrl];
};

export const useMfaSetup = (callBack = () => {}) => {
  const qc = useQueryClient();
  const { mutate, isLoading } = useMutation(mfaSetup, {
    onSuccess: (res) => {
      const is_mfa_enabled = res?.data?.data?.is_mfa_enabled;
      qc.invalidateQueries('my-profile');
      toastSuccess(
        `Successfully ${is_mfa_enabled ? 'enabled' : 'disabled'} MFA`,
      );
      callBack();
    },
    onError: (res) => {
      toastError(res?.response?.data?.message);
    },
  });
  return [isLoading, mutate];
};
